import { AccountObjectQueryFactory } from "../account-object/account-object.query-factory";
import { RestrictedAccountObject } from "./restricted-account-object.model";
import { isInArray } from "../../../core/util/is-in-array";
import { createSelector } from "reselect";
import { BaseObjectFilters } from "../../store/bootstrap";

export class RestrictedAccountObjectQueryFactory<T extends RestrictedAccountObject, F extends BaseObjectFilters> extends AccountObjectQueryFactory<T, F> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.query-factory.ts